export interface RpcResponse {
  success: boolean;
  data?: Array<string>;
  total?: number;
}

export enum ValidationErrorCode {
  MIN_LENGTH = 10,
  MAX_LENGTH = 20,
  DUPLICATE = 30,
  REQUIRED_ALLOW_TO_CHANGE = 31,
}
